import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { IsActiveMatchOptions, NavigationEnd, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseVerticalNavigationComponent } from '@fuse/components/navigation/vertical/vertical.component';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { FuseUtilsService } from '@fuse/services/utils/utils.service';
import { ApiService } from 'app/core/services/api.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';

@Component({
    selector: 'fuse-vertical-navigation-basic-item',
    templateUrl: './basic.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [],
})
export class FuseVerticalNavigationBasicItemComponent
    implements OnInit, OnDestroy
{
    @Input() item: FuseNavigationItem;
    @Input() name: string;

    isActiveMatchOptions: IsActiveMatchOptions;
    private _fuseVerticalNavigationComponent: FuseVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    defaultSavedView: any;
    unreadMsg: number = 0;
    lgParam: boolean;
    activeParam: any;
    iconPathSrc: any;
    isMatchId: any;
    activePath: any = window.location.pathname;
    activatedPlan: any;
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseUtilsService: FuseUtilsService,
        private _router: Router,
        public api: ApiService,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
    ) {
        // Set the equivalent of {exact: false} as default for active match options.
        // We are not assigning the item.isActiveMatchOptions directly to the
        // [routerLinkActiveOptions] because if it's "undefined" initially, the router
        // will throw an error and stop working.
        this.isActiveMatchOptions = this._fuseUtilsService.subsetMatchOptions;
        this.iconPathSrc = '/assets/icons/sidebar/';

        console.log('isActiveMatchOptions', this.isActiveMatchOptions);
        this.matIconRegistry
            .addSvgIcon(
                'announced',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}announced.svg`
                )
            )
            .addSvgIcon(
                'creadit_card',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}creadit_card.svg`
                )
            )
            .addSvgIcon(
                'settings',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}settings.svg`
                )
            )
            .addSvgIcon(
                'templates',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}template.svg`
                )
            )
            .addSvgIcon(
                'email_accounts',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}at.svg`
                )
            )
            .addSvgIcon(
                'integration',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}integration.svg`
                )
            )
            .addSvgIcon(
                'inbox',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}inbox.svg`
                )
            )
            .addSvgIcon(
                'prospect',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}prospect_management.svg`
                )
            )
            .addSvgIcon(
                'email-warmup',
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `${this.iconPathSrc}email-warmup.svg`
                )
            );

        this._router.events.subscribe((event: any) => {
            // if (event.routerEvent == NavigationEnd) {
            //     console.log("navigation event", event)
            // }
            if (event.routerEvent instanceof NavigationEnd) {
                this.activeParam = event.routerEvent.url;
                // if (param && param.id) {
                //     this.activeParam == param.id
                // }
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Set the "isActiveMatchOptions" either from item's
        // "isActiveMatchOptions" or the equivalent form of
        // item's "exactMatch" option
        // this.activePath = window.location.pathname
        this.api.currentPlanLoaded.subscribe({
            next: (res: boolean) => {
                if (res == true) {
                    setTimeout(() => {
                        this.activatedPlan = this.api.activatedPlan;
                        this._changeDetectorRef.detectChanges();
                    },500)
                }
            },
        });
        this._router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
              // Get the current route's URL and update window.location.pathname
            //   const currentUrl = this._router.url;
            this.activePath = this._router.url;
              console.log('current url',this.activePath)
              this._changeDetectorRef.detectChanges();
            }
          });

        this.isActiveMatchOptions =
            this.item.isActiveMatchOptions ?? this.item.exactMatch
                ? this._fuseUtilsService.exactMatchOptions
                : this._fuseUtilsService.subsetMatchOptions;
        // Get the parent navigation component
        this._fuseVerticalNavigationComponent =
            this._fuseNavigationService.getComponent(this.name);

        // Mark for check
        this.api.isLoadSettings
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this._changeDetectorRef.markForCheck();
            });
        this._changeDetectorRef.markForCheck();

        // Subscribe to onRefreshed on the navigation component
        this._fuseVerticalNavigationComponent.onRefreshed
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });

        this.api.isLoadSettings
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                if (res == true) {
                    this.unreadMsg = this.api.settingsData.inbox_badge;
                    console.log('unreadMsg', this.unreadMsg);
                }
            });

        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({ matchingAliases }) => {
                // Set the drawerMode and drawerOpened if
                if (matchingAliases.includes('lg')) {
                    this.lgParam = false;
                } else {
                    this.lgParam = true;
                }
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
